import { render, staticRenderFns } from "./agriculture.vue?vue&type=template&id=47ed2cea"
import script from "./agriculture.vue?vue&type=script&lang=js"
export * from "./agriculture.vue?vue&type=script&lang=js"
import style0 from "./agriculture.vue?vue&type=style&index=0&id=47ed2cea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports